import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import {
  CreateMarketingFlowPayload,
  MarketingFlow
} from "../../marketing.types";
import { requestCreateMarketingFlow } from "./createMarketingFlow.request";

const useCreateMarketingFlow = (
  options?: MutationOptions<
    MarketingFlow,
    ApiServiceError<ApiError>,
    CreateMarketingFlowPayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestCreateMarketingFlow,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({ queryKey: ["marketing", "flows"] });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useCreateMarketingFlow;
